/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontHead_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"StorefrontSocial_viewer">;
    readonly " $refType": "StorefrontHead_viewer";
};
export type StorefrontHead_viewer$data = StorefrontHead_viewer;
export type StorefrontHead_viewer$key = {
    readonly " $data"?: StorefrontHead_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontHead_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontHead_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontSocial_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '2d05f21453267818c21dab5d8922a2a2';
export default node;
